import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#1A1A1A] text-white py-10 text-center text-sm text-gray-400" data-id="element-43">
        <div className="max-w-[720px] mx-auto px-4" data-id="element-44">
          <p data-id="element-45">
            © {new Date().getFullYear()} Protocolo Anti-Inflamatorio 72h. Todos
            los derechos reservados.
          </p>
          <p className="mt-2 text-xs text-gray-500" data-id="element-46">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de comenzar cualquier régimen alimenticio.
          </p>

          <div className="mt-5 flex items-center justify-center gap-6" data-id="element-47">
            <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-white underline underline-offset-4 decoration-gray-600 hover:decoration-white transition-colors text-xs" data-id="element-48">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-49">·</span>
            <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-white underline underline-offset-4 decoration-gray-600 hover:decoration-white transition-colors text-xs" data-id="element-50">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-51">
        <p className="text-[#1A1A1A] font-semibold text-base" data-id="element-52">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-53">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-54">
          Al adquirir el Protocolo Anti-Inflamatorio 72h, recopilamos únicamente
          la información necesaria para procesar tu compra: nombre, dirección de
          correo electrónico y datos de pago. No almacenamos información de
          tarjetas de crédito en nuestros servidores; todo el procesamiento de
          pagos se realiza a través de plataformas de pago seguras de terceros.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-55">
          2. Uso de la Información
        </h3>
        <p data-id="element-56">Utilizamos tu información personal exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-57">
          <li data-id="element-58">Procesar y entregar tu compra digital.</li>
          <li data-id="element-59">Enviarte el enlace de descarga del protocolo.</li>
          <li data-id="element-60">Comunicarnos contigo en caso de problemas con tu pedido.</li>
          <li data-id="element-61">
            Enviarte actualizaciones del producto, solo si has dado tu
            consentimiento expreso.
          </li>
        </ul>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-62">
          3. Protección de Datos
        </h3>
        <p data-id="element-63">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Utilizamos cifrado SSL en todas
          las transmisiones de datos.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-64">4. Cookies</h3>
        <p data-id="element-65">
          Nuestro sitio web puede utilizar cookies para mejorar tu experiencia
          de navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies, aunque esto podría afectar algunas
          funcionalidades.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-66">
          5. Compartir Información con Terceros
        </h3>
        <p data-id="element-67">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación de nuestro sitio web y el procesamiento de
          pagos, siempre que dichas partes acuerden mantener esta información
          confidencial.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-68">6. Tus Derechos</h3>
        <p data-id="element-69">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. También puedes solicitar la portabilidad de tus
          datos o retirar tu consentimiento para el tratamiento de los mismos.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-70">
          7. Cambios en esta Política
        </h3>
        <p data-id="element-71">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta misma página
          con la fecha de actualización correspondiente.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-72">
        <p className="text-[#1A1A1A] font-semibold text-base" data-id="element-73">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-74">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-75">
          Al acceder y utilizar este sitio web y al adquirir el Protocolo
          Anti-Inflamatorio 72h, aceptas cumplir con estos términos y
          condiciones. Si no estás de acuerdo con alguna parte de estos
          términos, te rogamos que no utilices nuestro sitio ni adquieras
          nuestros productos.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-76">
          2. Naturaleza del Producto
        </h3>
        <p data-id="element-77">
          El Protocolo Anti-Inflamatorio 72h es un producto digital de carácter
          informativo y educativo. No constituye asesoramiento médico,
          diagnóstico ni tratamiento. Siempre consulta con un profesional de la
          salud calificado antes de realizar cambios en tu alimentación o estilo
          de vida.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-78">
          3. Producto Digital y Entrega
        </h3>
        <p data-id="element-79">
          Al completar tu compra, recibirás acceso inmediato al producto digital
          a través de un enlace de descarga. Dado que se trata de un producto
          digital de entrega inmediata, comprendes que recibirás el contenido de
          forma instantánea tras el pago.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-80">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-81">
          Todo el contenido del Protocolo Anti-Inflamatorio 72h, incluyendo
          textos, gráficos, imágenes, plantillas y materiales descargables, está
          protegido por derechos de autor. Queda prohibida su reproducción,
          distribución o reventa sin autorización expresa por escrito.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-82">5. Uso Permitido</h3>
        <p data-id="element-83">
          La licencia de compra es personal e intransferible. Puedes utilizar el
          material para tu uso personal y privado. No está permitido compartir,
          redistribuir, copiar o revender el contenido del protocolo.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-84">
          6. Descargo de Responsabilidad
        </h3>
        <p data-id="element-85">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que estos dependen de factores individuales
          como el estado de salud, la adherencia al protocolo y las condiciones
          personales de cada usuario. Este producto no pretende diagnosticar,
          tratar, curar ni prevenir ninguna enfermedad.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-86">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-87">
          En ningún caso seremos responsables por daños directos, indirectos,
          incidentales o consecuentes que resulten del uso o la incapacidad de
          uso del producto. El uso del protocolo es bajo tu propia
          responsabilidad.
        </p>

        <h3 className="text-[#1A1A1A] font-bold mt-4" data-id="element-88">8. Modificaciones</h3>
        <p data-id="element-89">
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación en el sitio web.
        </p>
      </Modal>
    </>;
}